<template>
  <div>
    <!------------------
            HEADER
    -------------------->
    <div class="bg-white p-3 pl-4 page-header" ref="pageHeader" style="padding-bottom: 0">
      <div class="row d-flex align-items-top">
        <div class="col">
          <div>
            <h4>
              <b-icon class="me-2" icon="file-person"></b-icon>
              Mein Profil
            </h4>
          </div>
        </div>
        <div class="col-auto">
          <div class="form-inline">
            <!---------------------------------
            HEADER ACTION BUTTONS
        ---------------------------------->
            <!-- Neue Vergabeeinheit -->
          </div>
        </div>
      </div>
    </div>
    <div class="main-canvas">
      <div class="row mt-1">
        <div class="col">
          <b-button @click="saveRecord" class="mr-2" size="sm">
            <b-icon icon="check-2" />
            Speichern
          </b-button>
          <b-button @click="sendPwResetMail" variant="outline-secondary" size="sm">
            <b-icon icon="key" class="mr-1" />
            Kennwort zurücksetzen
          </b-button>
          <b-button
            @click="leaveThisProjekt"
            variant="outline-secondary"
            size="sm"
            class="ml-2"
            v-if="!$root.$user.isSuperAdmin"
          >
            <b-icon icon="door-closed" class="mr-1" />
            Dieses Projekt verlassen
          </b-button>
        </div>
      </div>

      <div class="row mt-3" style="max-width:960px">
        <div class="col-8">
          <div class="row mt-1">
            <div class="col-12">
              <label class="text-muted">
                <small>Anzeigename</small>
              </label>

              <b-input disabled v-model="$root.$user.name" />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12">
              <label>
                <small class="text-muted">E-Mail Adresse (Anmeldename)</small>
                <b-icon
                  style="vertical-align: -0.15em; margin-left: 3px"
                  icon="info-circle"
                  title="Ihre E-Mail Adresse lässt sich nicht ändern. Lassen Sie sich gegebenfalls mit einer neuen Emailadresse von dem Projektadmin neu einladen"
                  class="text-muted"
                ></b-icon>
              </label>
              <b-input disabled v-model="$root.$user.email" />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-4">
              <label>
                <small class="text-muted">Benutzerdefinierte Farbe</small>
              </label>
              <b-input type="color" v-model="AppState.customPrimaryColor" />
            </div>
            <div class="col-3 align-self-end pl-0">
              <b-button size="sm" @click="appyCustomColor" variant="outline-secondary" style="height:35px">
                <b-icon icon="check2" />
              </b-button>
              <b-button size="sm" @click="resetCustomColor" style="height:35px" class="ml-2">
                <b-icon icon="x-circle" />
              </b-button>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12">
              <label><small class="text-muted">Meine Projekte</small></label>
              <ul>
                <li v-for="project of ProjectStore.projects" :key="project.DbId">
                  <span class="text-muted small">{{ project.ProjectIdentifier }}</span>
                  &nbsp;{{ project.Name }}&nbsp;
                  <span class="text-muted small">
                    <small>({{ calcAccessLevel(project) }})</small>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-4 bg-white border p-4 text-center " style="height:180px;margin-top:10px;">
          <input class="d-none" type="file" @change="onPicturePicked($event)" ref="fileInput" />
          <!-- <img :src="pictureData" class="uploadImage" @click="openFileDialog" /> -->
          <b-avatar button @click="openFileDialog" variant="info" :src="pictureData" size="6em"></b-avatar>
          <br />
          <div class="pt-3"><small>Klicken, um Foto auszuwählen</small></div>
        </div>
      </div>
      <!--
      <li>Persönliches Profilfoto</li>
      <li>Kundenzuordnung</li>
      <li>Berechtigte Projekte mit Rolle</li>-->

      <!-- <pre class="mt-5">{{ $root.$user }}</pre> -->
    </div>
  </div>
</template>

<script>
import AppState from '@/store/App.js';
import UsersService from '@/service/UserService';
import ProjectStore from '@/store/Projects';
export default {
  activated() {
    AppState.isLoading = false;
    UsersService.getUserPicture().then(image => (this.pictureData = Buffer.from(image).toString()));
  },
  data() {
    return {
      pictureData: null,
      ProjectStore,
      AppState
    };
  },
  methods: {
    onPicturePicked(e) {
      //console.log('zzz e', e.target.files[0]);
      const reader = new FileReader();

      reader.onload = event => {
        this.pictureData = event.target.result;
      };
      reader.readAsDataURL(e.target.files[0]);
    },
    sendPwResetMail() {
      UsersService.sendPwResetMail().then(() => {
        this.$bvModal.msgBoxOk(
          'Eine Mail mit einem Link zum Zurücksetzen des Kennworts wurde an ' + this.$root.$user.email + ' gesendet.',
          {
            title: 'Kennwort zurücksetzen',
            centered: true
          }
        );
      });
    },
    leaveThisProjekt() {
      this.$bvModal
        .msgBoxConfirm(
          'Sind Sie sicher, dass Sie das Projekt "' +
            this.ProjectStore.activeProject.Name +
            '" wirklich verlassen möchten? Sie können anschließend nicht mehr darauf zugreifen.',
          {
            title: 'Projekt verlassen',
            okVariant: 'danger',
            okTitle: 'Verlassen',
            cancelTitle: 'Abbrechen',
            centered: true
          }
        )
        .then(value => {
          if (value === true) {
            UsersService.leaveProject()
              .then(() => {
                this.$showSuccess(this, 'Projekt verlassen', 'Sie haben das Projekt erfolgreich verlassen.');
                setTimeout(() => {
                  window.location.reload();
                }, 2000);
              })
              .catch(err => {
                this.$showError(this, err.response?.data?.error || err.toString(), 'Projekt verlassen');
              });
          }
        });
    },
    openFileDialog() {
      this.$refs.fileInput.click();
    },
    saveRecord() {
      UsersService.setUserPicture(this.pictureData).then(() => {
        this.$root.$user.picture = Buffer.from(this.pictureData).toString();
        this.$showSuccess(this, 'Mein Profil', 'Profil erfolgreich gespeichert.');
      });
    },
    calcAccessLevel(project) {
      if (project.IsSuperAdmin == 'true') return 'Superadmin';
      if (project.IsAdmin == 'true') return 'Projektadmin';
      if (project.IsPlaner == 'true') return 'Assistenz';
      return 'Leser';
    },
    appyCustomColor() {
      this.$root.applyCustomTheme({ primaryColor: this.AppState.customPrimaryColor });
      this.$nextTick(() => {
        // router to home page to make sure the new theme is applied on all pages, then reload the page to make sure all components are re-rendered with the new theme
        this.$router.push('/');
      });
    },
    resetCustomColor() {
      this.AppState.customPrimaryColor = '#ff8000';
      this.appyCustomColor();
    }
  }
};
</script>

<style scoped>
.uploadImage {
  max-height: 200px;

  max-width: 200px;

  object-fit: cover;
  border: 1px solid #dee2e6;
}
</style>
